import React from "react"
import aerIcon from "assets/blackFriday2026/categoryIcons/aer.png"
import termiceIcon from "assets/blackFriday2026/categoryIcons/termice.png"
import apaIcon from "assets/blackFriday2026/categoryIcons/apa.png"
import sanitareIcon from "assets/blackFriday2026/categoryIcons/sanitare.png"
import energieIcon from "assets/blackFriday2026/categoryIcons/energie.png"

/**
 * Category icons of the Black Friday view + the brand slash motif. The five
 * sub-categories use the client's white line icons (the shop's category
 * icons redrawn in white for dark backgrounds, 2026-11-05; the glyph takes
 * the middle ~60% of the square). Only "Toate ofertele", which has no shop
 * icon, keeps a line icon in currentColor.
 */
const CATEGORY_ICON_SRC = {
  aer: aerIcon,
  termice: termiceIcon,
  apa: apaIcon,
  sanitare: sanitareIcon,
  energie: energieIcon
}

const base = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}

const Toate = () => (
  <g {...base}>
    <rect x="8" y="8" width="20" height="20" rx="3" />
    <rect x="36" y="8" width="20" height="20" rx="3" />
    <rect x="8" y="36" width="20" height="20" rx="3" />
    <rect x="36" y="36" width="20" height="20" rx="3" />
  </g>
)

export const BfCategoryIcon = ({ icon, size = 64, className = "", style }) => {
  const src = CATEGORY_ICON_SRC[icon]
  if (src)
    return (
      <img
        src={src}
        alt=""
        aria-hidden="true"
        draggable="false"
        className={`bf-icon bf-icon--img ${className}`}
        width={size}
        height={size}
        style={style}
      />
    )

  return (
    <svg
      className={`bf-icon ${className}`}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      aria-hidden="true"
      style={style}
    >
      <Toate />
    </svg>
  )
}

/** The Uniprest logo's diagonal, used as the campaign's signature mark. */
export const BfSlash = ({ className = "", color = "#ea0029", style }) => (
  <svg
    className={`bf-slash ${className}`}
    viewBox="0 0 1069 1095"
    aria-hidden="true"
    preserveAspectRatio="none"
    style={style}
  >
    <path d="M764.526 1095L0 0H304.474L1069 1095H764.526Z" fill={color} />
  </svg>
)

/** Lockup used in banners, tags and the hero: BLACK (white) / FRIDAY (red). */
export const BfWordmark = ({ className = "", stacked = false }) => (
  <span className={`bf-wordmark ${stacked ? "stacked" : ""} ${className}`}>
    <span className="bf-wordmark__black">Black</span>
    <span className="bf-wordmark__friday">Friday</span>
  </span>
)

export default BfCategoryIcon
